const state = () => ({
  theme: 'light',
  isPc: true,
  osName: '',
});

export default state;
